/* eslint-disable default-param-last */
import { summaryState, institutionsState, emailState } from 'models/common';
import { SUMMARY_ACTIONS, INSTITUTION_ACTIONS, EMAIL_ACTIONS } from 'actions/common';

export const CommonReducer = (state = summaryState, action) => {
  switch (action.type) {
    case SUMMARY_ACTIONS.GET_SUMMARY:
      return {
        ...state,
        isSummary: action.payload.flag
      };
    case SUMMARY_ACTIONS.GET_SUMMARY_DATA:
      return {
        ...state,
        summaryData: action.payload.data
      };
    default:
      return state;
  }
};

export const InstitutionReducer = (state = institutionsState, action) => {
  switch (action.type) {
    case INSTITUTION_ACTIONS.GET_INSTITUTION_DATA:
      return {
        ...state,
        treeData: action.payload.treeData
      };
    case INSTITUTION_ACTIONS.GET_ROSTERTREE_DATA:
      return {
        ...state,
        rosterTree: action.payload.treeData
      };
    default:
      return state;
  }
};

export const EmailReducer = (state = emailState, action) => {
  switch (action.type) {
    case EMAIL_ACTIONS.GET_TEMPLATES:
      return {
        ...state,
        templates: action.payload
      };
    case EMAIL_ACTIONS.GET_EMAIL_OBJECT:
      return {
        ...state,
        emailObject: action.payload
      };
    case EMAIL_ACTIONS.SEND_EMAIL:
      return {
        ...state,
        emailStatus: action.payload
      };
    case EMAIL_ACTIONS.GET_REASON:
      return {
        ...state,
        reasons: action.payload
      };
    case EMAIL_ACTIONS.GET_PSR:
      return {
        ...state,
        psr: action.payload
      };
    default:
      return state;
  }
};
